import { useState } from "react";

import { Leaderboard } from "./components/Leaderboard";
import { PlayerSelection } from "./components/PlayerSelection";
import { RosterSelection } from "./components/RosterSelection";
import { TeamTrends } from "./components/TeamTrends";

export default function Dashboard() {
  const [selectedTeamId, setSelectedTeamId] = useState<string | null>(null);

  return (
    <div className="mx-auto py-6 space-y-6 px-16">
      <RosterSelection
        selectedTeamId={selectedTeamId}
        setSelectedTeamId={setSelectedTeamId}
      />

      {selectedTeamId ? (
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          <div className="lg:col-span-1">
            <PlayerSelection selectedTeamId={selectedTeamId} />
          </div>

          <div className="lg:col-span-2 space-y-8">
            <Leaderboard teamId={selectedTeamId} />
            <TeamTrends teamId={selectedTeamId} />
          </div>
        </div>
      ) : (
        <p className="text-accent-dark-3">
          Select a team to view the dashboard
        </p>
      )}
    </div>
  );
}
